import { useState } from "react";

export const useNotification = () => {
  const [notification, setNotification] = useState(false);
  const [labelNotification, setLabelNotification] = useState("");
  const [backgroundColor, setBackgroundColor] = useState("#B8EFC9");

  const showNotification = (message: string, color = "#B8EFC9") => {
    setLabelNotification(message);
    setBackgroundColor(color);
    setNotification(true);

    setTimeout(() => {
      setNotification(false);
    }, 5000);
  };

  return {
    notification,
    labelNotification,
    backgroundColor,
    showNotification,
    setNotification,
  };
};
